import { useDeleteOtellConType } from "./api/deleteOtellConType";
import { Button } from "reactstrap";


const DeleteOtellConType = ({handleCloseModal, otellConTypeId}: DeleteOtellConTypeProps)  => {
  
  const deleteOtellConTypeMutation = useDeleteOtellConType({ otellConTypeId});
  const handleSubmit = async (): Promise<void> => {
    deleteOtellConTypeMutation.mutateAsync({ 
      otellConTypeId: otellConTypeId
    })

    handleCloseModal();
  }

  return (
    <>
        <label>Είστε σίγουροι οτι θέλετε να διαγράψετε το Είδος τηλεπ. γραμμής ΟΤΕ;</label>
        <div>
          <Button style={{ margin: "10px" }} onClick={handleCloseModal}>Ακύρωση</Button>
          <Button style={{ margin: "10px" }} color='danger' onClick={handleSubmit}>Διαγραφή</Button>
        </div>
    </>
  )
}

interface DeleteOtellConTypeProps{
  otellConTypeId: number;
  handleCloseModal: () => void;
}

export default DeleteOtellConType;